module.exports = __webpack_public_path__ + "img/culture_icon2.baef371b.png";